<template>
  <component :is="element" :class="classes" class="heading">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    display: {
      type: Number,
      required: true,
      validator: value => [1, 2, 3, 4].includes(value)
    },
    level: {
      type: Number,
      required: false,
      default: null,
      validator: value => !value || [1, 2, 3, 4, 5, 6].includes(value)
    }
  },
  computed: {
    classes() {
      return [`heading--${this.display}`];
    },
    element() {
      return this.level ? `h${this.level}` : 'div';
    }
  }
};
</script>

<style lang="scss" scoped>
.heading {
  line-height: 1.1;
  margin: 0;

  // display
  &--1 {
    @include font('crimson-pro', 'medium', 'italic');
    @include font-size('h1');
    letter-spacing: 0.01em;
  }

  &--2 {
    @include font('source-sans-pro', 'semibold');
    @include font-size('h2');
  }

  &--3 {
    @include font('crimson-pro', 'medium');
    @include font-size('h3');
  }

  &--4 {
    @include font('source-sans-pro', 'bold');
    @include font-size('h4');
  }
}
</style>
